export const formatTimeToKorean12Hour = (date: string): string => {
    const d = new Date(date);
    const hours = d.getHours();
    const minutes = d.getMinutes().toString().padStart(2, "0");
    const period = hours >= 12 ? "오후" : "오전";
    const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
    return `${period} ${formattedHours}:${minutes}`;
};
